export default __webpack_public_path__ + "static/media/saudedotrabalhador009.1f686187.svg";